import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';


// MM: This component redirects to step 1 when you try to load the webapp on step 2 upwards
// when you load from an email link or a BLANK new tab, history.length = 1
// when you copy paste a link in a new tab that defaults to a URL such as google, history.length = 2
// So initially I forced load on 1st step if history.length < 3
// however this caused issue if you opened intermediate step from email, it redirected to /create and you then legit navigated to step 2
// history.length = 2 and it falsely registered as loading in a new tab with INIT URL, and you had to click 'next' twice for it to work
// there is no way to differentiate
// so since there is more of a use case to open links from emails/bookmark, rather than copy past urls in tabs
// I changed the test to history.length < 2
// It means you can load on intermediate step if you copy paste the link in tabs that don't have a blank history. I'm afraid there is no way to just catch this one edge case
// also prevent loading step 1 with path mobile/fixed chosen as it makes no sense
// even though it would work (but url would be confusing)
/* eslint-disable react/jsx-props-no-spreading */
const RouteForceLoadOnFirstStep = React.memo(({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const loadAppOnIntermediateStep = ((props.history.length < 2) && props.match.params.stepId && (parseInt(props.match.params.stepId) > 1));
      const loadAppStepOneWithNetworkChosen = (props.match.params.stepId && (parseInt(props.match.params.stepId) === 1) && (props.match.params.crqNetwork === 'fixedOlo' ? 'fixed' : props.match.params.crqNetwork));
      // console.log('ForceLoadOnFirstStep loadAppOnIntermediateStep? loadAppStepOneWithNetworkChosen?', loadAppOnIntermediateStep, loadAppStepOneWithNetworkChosen, props);
      return (
        (loadAppOnIntermediateStep || loadAppStepOneWithNetworkChosen)
          ? (
            <Redirect
              to={{
                pathname: '/crq/create',
                state: { from: props.location },
              }}
            />
          )
          : <Component {...props} />
      );
    }}
  />
));


RouteForceLoadOnFirstStep.propTypes = {
  match: ReactRouterPropTypes.match,
  history: ReactRouterPropTypes.history,
  location: ReactRouterPropTypes.location,
  component: PropTypes.elementType,
};


export { RouteForceLoadOnFirstStep };
